import React from 'react';

const LogContent = ({log}) => {
  return (
    <>
      { log.map((v,i)=>{
          return (
            <div key={30+i} className='row collection-item green lighten-5'>
              <li>{v.date.slice(0,-6)}: {v.action}</li>
            </div>
          )
        })
      }
    </>
  );
};

export default LogContent;
